"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
fragment Member on BaseMember {
  id
  firstName
  lastName
  email
}

fragment Trainee on BaseTrainee {
  __typename
  id
  member {
    ...Member
  }
}

fragment PBPTrainee on CoachTrainee {
  ...Trainee
  lastMeasurement {
    week
  }
}
fragment PMPTrainee on TraineePMP {
  ...Trainee
}

query traineeList {
  trainees(application: [PMP]) {
    items {...PMPTrainee, ...PBPTrainee}
  }
}`;
//# sourceMappingURL=traineeList.js.map